import React from 'react';
import PageSeo from '@/seo/PageSeo';
import html2pdf from 'html2pdf.js';
import { sendGAPageview } from '../utils/gaConsent';
import LegalNoticeContentFromMarkdown from '../components/Legal/LegalNoticeContentFromMarkdown';
import $ from 'jquery';
import LegalDocumentLayout from '../components/Legal/LegalDocumentLayout';

export default function LegalNotice() {
  $('.popover').hide();
  sendGAPageview({
    hitType: 'pageview',
    page: '/legal-notice',
    title: 'Legal Notice',
  });

  const downloadSummary = () => {
    const element = document.getElementById('printer');
    if (!element) return;
    element.classList.add('pdf-mode');
    const opt = {
      margin: [20, 40, 40, 20] as [number, number, number, number],
      filename: 'legal-notice.pdf',
      image: { type: 'jpeg' as const, quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' as const },
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy'],
      },
    };
    html2pdf()
      .set(opt)
      .from(element)
      .save()
      .then(() => {
        element.classList.remove('pdf-mode');
      });
  };

  const sections = [
    { id: 'section1', number: '01', label: 'Who we are' },
    { id: 'section2', number: '02', label: 'Object' },
    { id: 'section3', number: '03', label: 'Use of the website' },
    { id: 'section4', number: '04', label: 'Privacy' },
    { id: 'section5', number: '05', label: 'Cookies' },
    { id: 'section6', number: '06', label: 'Commercial communications' },
    { id: 'section7', number: '07', label: 'Links' },
    { id: 'section8', number: '08', label: 'Industrial and intellectual property' },
    { id: 'section9', number: '09', label: 'Responsibility' },
    { id: 'section10', number: '10', label: 'Modifications' },
  ];

  const contactCard = {
    title: 'Contact DISGENET',
    email: 'info@disgenet.com',
    phone: '933037654',
  };

  return (
    <React.Fragment>
      <PageSeo
        title="Legal Notice | DISGENET"
        description="Legal notice and terms of use for the DISGENET website and gene-disease association platform."
        path="/legal-notice"
      />

      <section>
        <LegalDocumentLayout
          heroTag="Legal Notice"
          heroTitle={
            <>
              Legal <em>information</em> and terms of use
            </>
          }
          heroSubtitle="All the information governing the use of our website and platforms, including your rights and obligations as a user."
          sections={sections}
          contact={contactCard}
          onDownload={downloadSummary}
        >
          <LegalNoticeContentFromMarkdown />
        </LegalDocumentLayout>
      </section>
    </React.Fragment>
  );
}
